import React from 'react';

const PriceFilter = ({ minPrice, maxPrice, selectedPrice, onPriceChange }) => {
  return (
    <div style={{ padding: '20px', borderRight: '1px solid #ccc', width: '200px' }}>
      <h3>Filter by Price</h3>
      <input
        type="range"
        min={minPrice}
        max={maxPrice}
        value={selectedPrice}
        onChange={(e) => onPriceChange(Number(e.target.value))}
        style={{ width: '100%' }}
      />
      <p>Up to: ₹{selectedPrice}</p>
    </div>
  );
};

export default PriceFilter;
